import {useParams, Link} from "react-router-dom";
import {useEffect, useState} from "react";
import {Card, Col, Row, Tag, Tabs, Modal, notification, Popconfirm, Button} from "antd";
import dayjs from "dayjs";
import service from "../../api/FetchInterceptor";
import Attachments from "../../components/courrier/show/attachments";
import TimelineDossier from "../../components/courrier/show/timeline";
import {HasAccess} from "@permify/react-role"; 
import {RollbackOutlined} from "@ant-design/icons";

const statusColors = {
    submitted: "orange",
    waiting_affectation: "orange",
    in_progress: "blue",
    treated: "cyan",
    waiting_validation: "orange",
    validated: "green",
    pre_closed: "gold",
    closed: "default",
    classified: "default",
    sent: "purple",
    withdraw: "green",
    reject: "red",
};

const ShowDossier = () => {
    const {code} = useParams();
    const [dossier, setDossier] = useState(null);
    const [withdrawing, setWithdrawing] = useState(false);
    const [pvModalOpen, setPvModalOpen] = useState(false);
    const [resultFiles, setResultFiles] = useState([]);

    const urlParams = new URLSearchParams(window.location.search);
        
    const tab = urlParams.get('tab');

    const infosCourrier = dossier?.infosCourrier;

    useEffect(() => {
        loadDossier();
    }, [code]);

    const loadDossier = () => {

        service({
            method: "GET",
            url: `dossiers/${code}`,
        }).then((response) => {
            setDossier(response.data);
            console.log('retour :', response.data);
        }).finally(() => {
        });
    };

    const handleWithdrawDossier = () => {
        setWithdrawing(true);

        service({
            method: "POST",
            url: `dossiers/${code}/retrait`,
        }).then((response) => {
            notification.success({
                message: response.message,
            });

            setDossier(response.data);
            setPvModalOpen(true);
        }).catch((error) => {
            notification.error({
                message: error.response?.data?.message || 'Une erreur est survenue lors du retrait',
            });
        }).finally(() => {
            setWithdrawing(false);
        });
    };

    const loadResultTreatment = () => {
        service({
            method: "GET",
            url: `dossiers/${code}/result-treatment`,
        }).then((response) => {
            console.log("Réponse result-treatment:", response);
            console.log("Réponse result-treatment (data):", response.data);
            setResultFiles(response.data);
        });
    };

    useEffect(() => {
        if (infosCourrier?.retire) {
            loadResultTreatment();
        }
    }, [infosCourrier?.retire]);

    if (!dossier) {
        return <div>Dossier introuvable</div>;
    }

    return (
        <Row gutter={[16, 16]}>
            <Modal
                title="Procès-verbal"
                open={pvModalOpen}
                onCancel={() => setPvModalOpen(false)}
                footer={null}
                width={800}
            >
                {infosCourrier.pv?.fichier ? (
                    <a target="_blank" rel="noreferrer" href={infosCourrier.pv.fichier.path} download>
                        Voir / télécharger le PV
                    </a>
                ) : (
                    <div>Aucun PV disponible</div>
                )}
            </Modal>
            <Col xs={24} xl={16}>
                <Card 
                    title="Détails du dossier"

                    extra={
                        <HasAccess permissions="WITHDRAW_DOSSIER">
                            {infosCourrier.canWithdraw && !infosCourrier.retire && (
                                <Popconfirm
                                    title="Confirmer le retrait du dossier ?"
                                    onConfirm={handleWithdrawDossier}
                                >
                                    <Button
                                        type="primary"
                                        icon={<RollbackOutlined/>}
                                        loading={withdrawing}
                                        style={{backgroundColor: "#08aba6", borderColor: "#52c41a"}}
                                    >
                                        Retirer le dossier
                                    </Button>
                                </Popconfirm>
                            )}
                        </HasAccess>
                    }
                >
                    <Tabs
                        defaultActiveKey={tab ?? "dossier"}
                        items={[
                            {
                                label: `Dossier`,
                                key: 'dossier',
                                children: <Attachments attachments={dossier.piecesJointes}/>,
                            },

                            {
                                label: `Suivi du traitement`,
                                key: 'timeline',
                                children: <TimelineDossier code={code}/>,
                            },

                            ...(infosCourrier.retire ? [
                                {
                                    label: `Résultat du traitement`,
                                    key: 'resultat',
                                    children: <Attachments attachments={resultFiles}/>,
                                },
                            ] : []),
                        ]}
                    />
                </Card>
            </Col>

            <Col xs={24} xl={8}>
                <Card title="Informations du dossier">
                    <table className="inline-table">
                        <tbody>
                        <tr>
                            <th>Statut du dossier</th>
                            <td>
                                <Tag color={statusColors[infosCourrier.status_ac] || "default"}>
                                    {infosCourrier.statusAcLabel}
                                </Tag>
                            </td>
                        </tr>

                        {infosCourrier.status_ac === "reject" && infosCourrier.commentaire && (
                            <tr>
                                <th>Motif du rejet</th>
                                <td>{infosCourrier.commentaire}</td>
                            </tr>
                        )}

                        {infosCourrier.treatedAt && (
                            <tr>
                                <th>Date de transmission du résultat</th>
                                <td>
                                    {dayjs(infosCourrier.treatedAt).format('DD/MM/YYYY HH:mm')}
                                </td>
                            </tr>
                        )}

                        <tr>
                            <th>Numéro</th>
                            <td>{infosCourrier.numero}</td>
                        </tr>

                        <tr>
                            <th>Référence du BE</th>
                            <td>{infosCourrier.reference}</td>
                        </tr>

                        <tr>
                            <th>Objet</th>
                            <td>{infosCourrier.objet}</td>
                        </tr>

                        <tr>
                            <th>Date d'émission du BE</th>
                            <td>
                                {infosCourrier.date
                                    ? dayjs(infosCourrier.date).format('DD/MM/YYYY')
                                    : '-'}
                            </td>
                        </tr>

                        <tr>
                            <th>Date de soumission</th>
                            <td>
                                {infosCourrier.dateSoumission
                                    ? dayjs(infosCourrier.dateSoumission).format('DD/MM/YYYY HH:mm')
                                    : '-'}
                            </td>
                        </tr>

                        <tr>
                            <th>Type de dossier</th>
                            <td>{infosCourrier.typeDossier?.libelle}</td>
                        </tr>

                        <tr>
                            <th>Nature de dossier</th>
                            <td>{infosCourrier.natureMarche?.libelle}</td>
                        </tr>

                        <tr>
                            <th>Type de marché</th>
                            <td>{infosCourrier.typeMarche?.libelle}</td>
                        </tr>

                        {infosCourrier.pv?.fichier && (
                            <tr>
                                <th>Référence du PV</th>
                                <td>
                                    <a target="_blank" rel="noreferrer" href={infosCourrier.pv.fichier.path}>
                                        {infosCourrier.referencePV}
                                    </a>
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </Card>
            </Col>
        </Row>
    );
};

export default ShowDossier;